import { Stack, Typography } from '@mui/material';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { pointsNextStep, setDateTime } from '../../../actions/points';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import StepActions from './StepActions';

export default function Step0() {
  const dispatch = useAppDispatch();
  const dateTime = useAppSelector((s) => s.points.dateTime);
  const value = new Date(dateTime);

  const setDate = (next: Date | null) => {
    if (!next) {
      return;
    }
    const merged = new Date(next.getTime());
    merged.setHours(value.getHours(), value.getMinutes(), 0, 0);
    dispatch(setDateTime(merged.toISOString()));
  };

  const setTime = (next: Date | null) => {
    if (!next) {
      return;
    }
    const merged = new Date(value.getTime());
    merged.setHours(next.getHours(), next.getMinutes(), 0, 0);
    dispatch(setDateTime(merged.toISOString()));
  };

  return (
    <Stack className="step0" spacing={2} alignItems="flex-start">
      <Typography variant="h6">Wybierz datę i czas</Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} useFlexGap>
        <DatePicker label="Wybierz datę" value={value} onChange={setDate} />
        <TimePicker label="Wybierz czas" ampm={false} value={value} onChange={setTime} />
      </Stack>
      <StepActions onNext={() => dispatch(pointsNextStep())} />
    </Stack>
  );
}
